module.exports = __webpack_public_path__ + "hM0gekQOUVruWAbHF/RDC_RED_Logo_House.svg";